import { StorageError } from './errors.js';
import { assertDocumentIdentity, assertJsonValue, assertStoredDocument } from './validation.js';
export function defaultClock() {
    return { now: () => new Date().toISOString() };
}
export function defaultIdSource() {
    return {
        create: () => {
            if (typeof globalThis.crypto?.randomUUID !== 'function') {
                throw new StorageError('unsupported', { detail: 'crypto.randomUUID is required for operation ids' });
            }
            return globalThis.crypto.randomUUID();
        },
    };
}
export function documentKey(type, id) {
    assertDocumentIdentity(type, id);
    return `${type}\u0000${id}`;
}
export function checkExpectedVersion(current, expectedVersion) {
    if (expectedVersion === undefined)
        return;
    if (expectedVersion === null && current === undefined)
        return;
    if (typeof expectedVersion === 'number' && current?.version === expectedVersion)
        return;
    throw new StorageError('conflict');
}
export function createPutDocument(input, current, updatedAt) {
    assertDocumentIdentity(input.type, input.id);
    assertJsonValue(input.data);
    const document = {
        id: input.id,
        type: input.type,
        version: (current?.version ?? 0) + 1,
        createdAt: current?.createdAt ?? updatedAt,
        updatedAt,
        deletedAt: null,
        data: structuredClone(input.data),
    };
    assertStoredDocument(document);
    return document;
}
export function createDeletedDocument(current, deletedAt) {
    const document = {
        ...structuredClone(current),
        version: current.version + 1,
        updatedAt: deletedAt,
        deletedAt,
    };
    assertStoredDocument(document);
    return document;
}
export function operationInputForDocument(document, kind, opId) {
    return {
        opId,
        kind,
        documentType: document.type,
        documentId: document.id,
        documentVersion: document.version,
        payload: structuredClone(document),
        createdAt: document.updatedAt,
    };
}
//# sourceMappingURL=model.js.map